/** App Pages */
export const RESET_CURPAGE = 'RESET_CURPAGE';
export const RESET_ALL_DATA = 'RESET_ALL_DATA';

export const SET_CURPAGE_DATA = 'SET_CURPAGE_DATA';
export const SET_CURPAGE_IS_ERROR = 'SET_CURPAGE_IS_ERROR';
export const SET_LOGIN_DATA = 'SET_LOGIN_DATA';
export const SET_PAYMENT_DATA = 'SET_PAYMENT_DATA';
export const SET_PAYMENT_STATUS = 'SET_PAYMENT_STATUS';
export const SET_TRANSACTION_DATA = 'SET_TRANSACTION_DATA';

export const SET_LISTENER_START = 'SET_LISTENER_START';
export const SET_LISTENER_QR_REGISTERED = 'SET_LISTENER_QR_REGISTERED';
export const SET_SESSION_EXPIRED = 'SET_SESSION_EXPIRED';

export const SET_MAX_LOGIN_TRIES_REACHED = 'SET_MAX_LOGIN_TRIES_REACHED';
export const SET_MAX_2FA_TRIES_REACHED = 'SET_MAX_2FA_TRIES_REACHED';
export const SET_MAX_RESEND_OTP_REACHED = 'SET_MAX_RESEND_OTP_REACHED';

export const SET_PAYMENT_ERROR = 'SET_PAYMENT_ERROR';
export const SET_2FA_OTP = 'SET_2FA_OTP';

export const SET_MERCHANT_INFO = 'SET_MERCHANT_INFO';
export const SET_REDIRECT_URL = 'SET_REDIRECT_URL';
export const SET_QUERY_FAILED = 'SET_QUERY_FAILED';
export const SET_DEFAULT_ERROR = 'SET_DEFAULT_ERROR';

export const STOP_QUERY_POLLING = 'STOP_QUERY_POLLING';
export const USER_TRIGGERED_LEAVE = 'USER_TRIGGERED_LEAVE';

export const SET_IS_LOADING = 'SET_IS_LOADING';
export const SET_IS_VERIFYING = 'SET_IS_VERIFYING';
export const SET_IS_GUEST = 'SET_IS_GUEST';
export const SET_IS_SKIP_LOGIN = 'SET_IS_SKIP_LOGIN';

export const SET_TOPUP_DATA = 'SET_TOPUP_DATA';